import React from 'react';
import { motion } from 'framer-motion';
import { FaStar } from 'react-icons/fa';

const rawTestimonials = [
  { text: "HostFig transformed our online presence. Their support and expertise are unmatched.", name: "John Smith", role: "CEO, TechFlow", rating: 5.0, seed: "john" },
  { text: "The team is professional, responsive, and delivers exceptional results.", name: "Sarah Johnson", role: "Marketing Director", rating: 5.0, seed: "sarah" },
  { text: "Reliable, innovative, and dedicated to our success. Highly recommend!", name: "Michael Brown", role: "Founder, StartupsXYZ", rating: 5.0, seed: "michael" },
  { text: "We migrated 15 complex sites to HostFig with zero downtime. Phenomenal service.", name: "David Chen", role: "CTO, Frame Studio", rating: 5.0, seed: "david" },
  { text: "The catalog images produced by HostFig Studio completely transformed our product pages. Breathtaking quality.", name: "Elena Rodriguez", role: "Creative Director", rating: 5.0, seed: "elena" },
  { text: "I've never experienced hosting this fast. Our bounce rate dropped instantly.", name: "Marcus Webb", role: "E-Commerce Owner", rating: 5.0, seed: "marcus" },
  { text: "HostFig handles everything so my team can just focus on building our product.", name: "Sophia Lee", role: "Startup Founder", rating: 5.0, seed: "sophia" },
  { text: "The custom dashboard and analytics they provided gave us total clarity.", name: "James Wilson", role: "Product Manager", rating: 5.0, seed: "james" },
  { text: "Unbeatable uptime. We trust them with our most critical enterprise applications.", name: "Ahmed Patel", role: "SysAdmin", rating: 5.0, seed: "ahmed" },
  { text: "From prompt to production, the speed at which they deliver is astonishing.", name: "Mason Carter", role: "Creative Director", rating: 5.0, seed: "mason" },
  { text: "Their team acts like an extension of ours. Truly a reliable technology partner.", name: "Olivia Wright", role: "VP of Engineering", rating: 5.0, seed: "olivia" },
  { text: "Our organic traffic skyrocketed after they re-architected our web infrastructure.", name: "Liam Davis", role: "Growth Marketer", rating: 5.0, seed: "liam" }
];

const TestimonialCard = ({ item }) => (
  <div className="w-[300px] md:w-[380px] p-6 bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] flex flex-col flex-shrink-0 mx-3 hover:shadow-md transition-shadow">
    <div className="flex gap-1 mb-4">
      {[...Array(5)].map((_, i) => (
        <FaStar key={i} className="w-4 h-4 text-blue-500" />
      ))}
    </div>
    <p className="text-slate-600 text-[15px] md:text-[16px] leading-[1.6] flex-grow mb-6 line-clamp-4">
      "{item.text}"
    </p>
    <div className="flex items-center gap-3">
      <img src={`https://i.pravatar.cc/150?u=${item.seed}`} alt={item.name} className="w-10 h-10 rounded-full object-cover grayscale opacity-80" />
      <div>
        <h4 className="font-bold text-slate-900 text-[15px]">{item.name}</h4>
        <p className="text-[13px] text-slate-500">{item.role}</p>
      </div>
    </div>
  </div>
);

const TestimonialsSection = () => {
  const row1 = rawTestimonials.slice(0, 6);
  const row2 = rawTestimonials.slice(6, 12);
  const seamlessRow1 = [...row1, ...row1, ...row1];
  const seamlessRow2 = [...row2, ...row2, ...row2];

  return (
    <section className="bg-white border-t border-slate-100 w-full py-24 relative overflow-hidden flex flex-col items-center">
      <style>
        {`
          @keyframes marquee-left {
            0% { transform: translateX(0); }
            100% { transform: translateX(-33.333333%); }
          }
          @keyframes marquee-right {
            0% { transform: translateX(-33.333333%); }
            100% { transform: translateX(0); }
          }
          .animate-marquee-left {
            animation: marquee-left 40s linear infinite;
          }
          .animate-marquee-right {
            animation: marquee-right 40s linear infinite;
          }
          .marquee-container:hover .animate-marquee-left,
          .marquee-container:hover .animate-marquee-right {
            animation-play-state: paused;
          }
        `}
      </style>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="text-center mb-16 max-w-2xl mx-auto px-6"
      >
        <h2 className="text-slate-900 text-[36px] md:text-[52px] font-bold leading-[1.1] mb-6 tracking-tight">
          Trusted by <span className="text-blue-600">businesses</span> turning ideas into products
        </h2>
        <p className="text-slate-600 text-[16px] md:text-[18px] leading-relaxed">
          See how founders and teams are building, launching, and scaling apps faster with HostFig — without the usual complexity.
        </p>
      </motion.div>

      <div className="relative w-full marquee-container flex flex-col gap-6">
        <div className="absolute inset-y-0 left-0 w-16 md:w-48 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-16 md:w-48 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>
        
        <div className="flex w-max animate-marquee-left">
          {seamlessRow1.map((item, idx) => (
            <TestimonialCard key={`r1-${idx}`} item={item} />
          ))}
        </div>
        <div className="flex w-max animate-marquee-right">
          {seamlessRow2.map((item, idx) => (
            <TestimonialCard key={`r2-${idx}`} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;